export function dismissComment(e, container, callback) {
  const element = $(e.currentTarget).closest(".comment-item");

  element.animate({ opacity: '0' }, 200, ()=> {
    element.animate({ height: '0' }, 200, ()=> {
      element.remove();
      return (callback() != null);
    });
  });
};


export function dismissComments(container, callback) {
  const dismiss_comments = container.find(".clear-notifications");

  dismiss_comments.on("click", e=> {
    e.preventDefault();
    e.stopPropagation();
    const commentIds = container.find(".comment-item:not(.ai-usage-notification)").map((i, el)=> $(el).attr("data-id")).toArray();
    const aiNotifIds = container.find(".ai-usage-notification").map((i, el)=> $(el).attr("data-notification-id")).toArray();

    const requests = [];
    if (commentIds.length > 0) {
      requests.push($.post("/comments/acknowledge_batch", { ids: commentIds.join(",") }));
    }
    if (aiNotifIds.length > 0) {
      requests.push($.post("/navbar_notifications/dismiss_ai_notifications", { ids: aiNotifIds.join(",") }));
    }

    $.when(...requests).then(() => {
      container.find(".comment-item").remove();
      dismiss_comments.hide();
      return (callback() != null);
    }).fail((e) => {
      const errorMessage = e?.responseJSON?.error;
      alert(errorMessage || "Something went wrong.");
    });
  });
};

export function dismissAiNotification(e, container, callback) {
  const element = $(e.currentTarget).closest(".ai-usage-notification");
  const notifId = element.attr("data-notification-id");

  $.post("/navbar_notifications/dismiss_ai_notifications", { ids: notifId }, () => {
    element.animate({ opacity: '0' }, 200, ()=> {
      element.animate({ height: '0' }, 200, ()=> {
        element.remove();
        return (callback() != null);
      });
    });
  });
};
